var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8583 5.30226H15.961L11.0466 0.387878V3.49063C11.0466 4.49012 11.8597 5.30226 12.8583 5.30226Z",
    fill: "#83829B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0349 11.0465H5.96509C5.59922 11.0465 5.30229 10.7495 5.30229 10.3837C5.30229 10.0178 5.59922 9.72089 5.96509 9.72089H13.0349C13.4007 9.72089 13.6977 10.0178 13.6977 10.3837C13.6977 10.7495 13.4007 11.0465 13.0349 11.0465ZM13.0349 14.5814H5.96509C5.59922 14.5814 5.30229 14.2844 5.30229 13.9186C5.30229 13.5527 5.59922 13.2558 5.96509 13.2558H13.0349C13.4007 13.2558 13.6977 13.5527 13.6977 13.9186C13.6977 14.2844 13.4007 14.5814 13.0349 14.5814ZM5.96509 6.186H7.73253C8.09839 6.186 8.39533 6.48293 8.39533 6.84879C8.39533 7.21465 8.09839 7.51159 7.73253 7.51159H5.96509C5.59922 7.51159 5.30229 7.21465 5.30229 6.84879C5.30229 6.48293 5.59922 6.186 5.96509 6.186ZM5.96509 2.65111H7.73253C8.09839 2.65111 8.39533 2.94804 8.39533 3.3139C8.39533 3.67976 8.09839 3.97669 7.73253 3.97669H5.96509C5.59922 3.97669 5.30229 3.67976 5.30229 3.3139C5.30229 2.94804 5.59922 2.65111 5.96509 2.65111ZM12.8581 6.62786C11.1287 6.62786 9.72091 5.22097 9.72091 3.49064V-6.10352e-05H4.19764C3.34485 -6.10352e-05 2.65112 0.693662 2.65112 1.54645V17.4535C2.65112 18.3063 3.34485 19 4.19764 19H14.8023C15.6551 19 16.3488 18.3063 16.3488 17.4535V6.62786H12.8581Z",
    fill: "#83829B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.573786296ae894481705db1c76ffa775.svg";
export { ForwardRef as ReactComponent };